import { Backdrop, Box, LinearProgress } from '@mui/material';
import splash from '@/assets/images/pcomm.svg';

export const SplashScreen = () => {
	return (
		<Backdrop
			sx={{
				backgroundColor: 'white',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column'
			}}
			open>
			<Box marginBottom={2}>
				<img
					height={450}
					src={splash}
					alt='Precision Communications'
				/>
			</Box>
			<Box sx={{ width: '25%' }}>
				<LinearProgress />
			</Box>
		</Backdrop>
	);
};
